import React, { useState } from 'react';
import { Star } from 'lucide-react';

export default function StarRating({ 
  rating = 0, 
  onRate, 
  size = 'sm',
  readonly = false 
}) {
  const [hover, setHover] = useState(0);
  
  const sizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };
  
  const iconSize = sizeClasses[size] || sizeClasses.sm;
  
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={readonly}
          onClick={() => !readonly && onRate && onRate(star === rating ? 0 : star)}
          onMouseEnter={() => !readonly && setHover(star)}
          onMouseLeave={() => !readonly && setHover(0)}
          className={`${readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'} transition-transform focus:outline-none`}
        >
          <Star
            className={`${iconSize} ${
              star <= (hover || rating)
                ? 'fill-amber-400 text-amber-400'
                : 'fill-transparent text-slate-300'
            } transition-colors`}
          />
        </button>
      ))}
    </div>
  );
}
